import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Home/Index'
import About from '@/components/About/About'
import Container from '@/components/Home/Container'
import GameDetail from '@/components/Home/GameDetail'
import Agreement from '@/components/About/Agreement'
import Custody from '@/components/Custody/Custody'
import CustodyIndex from '@/components/Custody/CustodyIndex'
import ApplyReg from '@/components/Custody/ApplyReg'
import ApplyNotice from '@/components/Custody/ApplyNotice'
import Question from '@/components/Custody/Question'
import Dispute from '@/components/About/Dispute'
import BackIndulge from '@/components/About/BackIndulge'
import News from '@/components/About/News'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/', 
      component: Index,
      children:[ 
        {
          path:'',
          name:'Container',
          component:Container,
        },
        {
          path:'gameDetail',
          name:'GameDetail',
          component:GameDetail
        },
        {
          path:'about',
          name:'About',
          component:About,
        },
        {
          path:"agreement",
          name:'Agreement',
          component:Agreement
        },
        {
          path:"custody", 
          component:Custody,
          children:[
            {
              path:'',
              name:'CustodyIndex',
              component:CustodyIndex
            },
            {
              path:'applyReg',
              name:'ApplyReg',
              component:ApplyReg
            },
            {
              path:'applyNotice',
              name:'ApplyNotice',
              component:ApplyNotice
            },
            {
              path:'question',
              name:'Question',
              component:Question
            }
          ]
        },
        {
          path:"dispute",
          name:"Dispute",
          component:Dispute,
        },
        {
          path:'backIndulge',
          name:'BackIndulge',
          component:BackIndulge
        },
        {
          path:'news',
          name:'News',
          component:News
        } 
      ]
    } 
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js